import { render } from "./customeHomeworkRecord.vue?vue&type=template&id=b4fa5d22&scoped=true"
import script from "./customeHomeworkRecord.vue?vue&type=script&lang=js"
export * from "./customeHomeworkRecord.vue?vue&type=script&lang=js"

import "./customeHomeworkRecord.vue?vue&type=style&index=0&id=b4fa5d22&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fa5d22"]])

export default __exports__